<template>
  <div
    class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
    v-if="!loading"
  >
    <div class="max-w-md w-full">
      <div>
        <router-link to="/">
          <img
            class="mx-auto h-12 w-auto"
            src="/logo.png"
            alt="ScaffoldHub"
          />
        </router-link>

        <h2
          class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
        >
          Sign in to your account
        </h2>
      </div>
      <form
        class="mt-8"
        @submit.prevent="signinWithEmailAndPassword()"
      >
        <div class="rounded-md shadow-sm">
          <div>
            <input
              aria-label="Email address"
              name="email"
              type="email"
              required
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
              placeholder="Email address"
              v-model="email"
              @keyup.enter="signinWithEmailAndPassword()"
              autofocus
            />
          </div>
          <div class="-mt-px">
            <input
              aria-label="Password"
              name="password"
              type="password"
              required
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
              placeholder="Password"
              v-model="password"
              @keyup.enter="signinWithEmailAndPassword()"
            />
          </div>
        </div>

        <div class="mt-6 flex items-center justify-between">
          <div class="flex items-center">
            <input
              v-model="rememberMe"
              id="remember_me"
              type="checkbox"
              class="form-checkbox h-4 w-4 text-blue-600 transition duration-150 ease-in-out"
            />
            <label
              for="remember_me"
              class="ml-2 block text-sm leading-5 text-gray-900"
            >
              Remember me
            </label>
          </div>

          <div class="text-sm leading-5">
            <router-link
              to="/auth/forgot-password"
              class="font-medium text-blue-600 hover:text-blue-500 focus:outline-none focus:underline transition ease-in-out duration-150"
            >
              Forgot your password?
            </router-link>
          </div>
        </div>

        <div class="mt-6">
          <el-button
            class="w-full"
            type="primary"
            :disabled="loading"
            @click="signinWithEmailAndPassword()"
          >
            Sign in
          </el-button>

          <div class="separator my-5">Or continue with</div>

          <div class="flex justify-between">
            <el-button
              :disabled="loading"
              class="text-gray-500 ml-1 w-6/12"
              @click="signinWithGoogle(true)"
            >
              <i class="fab fa-google mr-2"></i>
              Google
            </el-button>
            <el-button
              :disabled="loading"
              class="text-gray-500 mr-1 w-6/12"
              @click="signinWithGitHub(true)"
            >
              <i class="fab fa-github mr-2"></i>
              GitHub
            </el-button>
          </div>

          <div
            class="mt-4 text-xs text-center text-gray-900"
          >
            By signing in and using the service <br />you
            agree with the
            <a
              class="text-blue-500"
              href="https://scaffoldhub.io/license"
              >ScaffoldHub License</a
            >
            terms.
          </div>

          <div class="mt-5 w-full text-center">
            <router-link
              class="text-sm font-normal text-blue-600 hover:text-blue-500 focus:outline-none focus:underline transition ease-in-out duration-150"
              to="/"
            >
              Back to generator
            </router-link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import authReferrer from '@/auth/auth-referrer';

export default {
  name: 'app-auth-sign-in',

  data() {
    return {
      email: null,
      password: null,
      rememberMe: true,
    };
  },

  async created() {
    const authenticated = await this.$store.getters[
      'auth/authenticatedAsync'
    ]();

    if (authenticated) {
      this.$router.push(authReferrer.get() || '/');
      authReferrer.remove();
      return;
    }

    if (this.$route.query.referrer) {
      authReferrer.add(this.$route.query.referrer);
    }
  },

  computed: {
    ...mapGetters({
      loading: 'auth/loading',
    }),
  },

  methods: {
    ...mapActions({
      signinWithGoogle: 'auth/signinWithGoogle',
      signinWithGitHub: 'auth/signinWithGitHub',
      authSigninWithEmailAndPassword:
        'auth/signinWithEmailAndPassword',
    }),

    signinWithEmailAndPassword() {
      return this.authSigninWithEmailAndPassword({
        email: this.email,
        password: this.password,
        rememberMe: this.rememberMe,
      });
    },
  },
};
</script>

<style></style>
